import MobileBeddingSection from './MobileBeddingSection';

export default MobileBeddingSection;
